var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99976 9.99902C5.99976 8.11342 5.99976 7.17062 6.58554 6.58481C7.17136 5.99902 8.11416 5.99902 9.99976 5.99902H10.6664C12.552 5.99902 13.4948 5.99902 14.0806 6.58481C14.6664 7.17062 14.6664 8.11342 14.6664 9.99902V10.6657C14.6664 12.5513 14.6664 13.4941 14.0806 14.0799C13.4948 14.6657 12.552 14.6657 10.6664 14.6657H9.99976C8.11416 14.6657 7.17136 14.6657 6.58554 14.0799C5.99976 13.4941 5.99976 12.5513 5.99976 10.6657V9.99902Z",
    stroke: "#BCBBB7",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3332 5.99948C11.3316 4.02808 11.3018 3.00695 10.7279 2.30776C10.6171 2.17274 10.4933 2.04893 10.3583 1.93812C9.62072 1.33281 8.52492 1.33281 6.33325 1.33281C4.1416 1.33281 3.04577 1.33281 2.30821 1.93812C2.17318 2.04892 2.04937 2.17274 1.93856 2.30776C1.33325 3.04533 1.33325 4.14116 1.33325 6.33281C1.33325 8.52448 1.33325 9.62028 1.93856 10.3579C2.04937 10.4929 2.17318 10.6167 2.30821 10.7275C3.00739 11.3013 4.02853 11.3311 5.99992 11.3327",
    stroke: "#BCBBB7",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.a8bf9b3d40a62457302eb93655586fad.svg";
export { ForwardRef as ReactComponent };